import BankwiseOffersList from "../../../jsx/components/Dashboard/BankwiseOffer/bankwiseofferslist";

const BankWiseOffersListWrapper = () => {
  return <BankwiseOffersList />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.connector];

export default constore(BankWiseOffersListWrapper);
